import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { Button, ClearVerifyLogo, Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const UserEmailConfirmRequestErrorModal: React.FC = () => {
  const { closeModal, isOpen } = useModal(ModalId.UserEmailConfirmRequestErrorModal);

  const navigate = useNavigate();

  const onCloseModal = React.useCallback(() => {
    navigate(appRoutes.root);
    closeModal();
  }, [closeModal, navigate]);

  return (
    <Modal
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={400}
    >
      <Grid container spacing={2}>
        <Grid mb={1} size={12}>
          <ClearVerifyLogo />
        </Grid>
        <Grid mb={1} size={12}>
          <Typography variant="h5" textAlign="center">
            Email not confirmed.
          </Typography>
        </Grid>
        <Grid mb={4} size={12}>
          <Typography variant="body2" textAlign="center">
            <span>Try to create new Change Email Request at </span>
            <Link to={appRoutes.account.security}>Account Security Page</Link>
          </Typography>
        </Grid>
        <Grid container justifyContent="center" size={12}>
          <Button variant="contained" color="error" onClick={onCloseModal}>
            Close
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};
